import {customAxiosBE} from "../config";
import moment from "moment";
import {customForSaleparsePaginationParams, parsePaginationParams} from "../../utils/other";


export async function getAllMultiPassAPI(payload, params) {
    return customAxiosBE.post(`/multiPass/search?${params}`, payload)
}

export async function insertMultiPassAPI(data) {
    return customAxiosBE.post(`/multiPass`, data)
}

export async function extendMultiPassAPI(data) {
    return customAxiosBE.post(`/multiPass/extend`, data)
}

export async function deleteMultiPassAPI(id) {
    return customAxiosBE.delete(`/multiPass/${id}`)
}

export async function updateMultiPassAPI(data){
    return customAxiosBE.put(`/multiPass`, data)
}

export async function extendMultiPassBatchAPI(data) {
    return customAxiosBE.post(`/multiPass/extend/batch`, data);
}

export async function ticketsMultiPassViewAPI(payload) {
    const { filter, params } = payload;
    let salesTime = filter?.salesTime ? moment(filter.salesTime).format("YYYY-MM-DD") : null;

    let journeyDate = filter?.journeyDate ? moment(filter.journeyDate).format("YYYY-MM-DD") : null;

    let directionType = filter?.directionType === "daily" ? "Dnevna" : null
    let isReturnTicket = filter?.directionType === "all"
        ? null : filter?.directionType === "daily" ? null
        : filter.directionType !== "oneWay";

    let carrierId = filter?.carrier != null ? filter?.carrier?.id : null
    let lineId = filter?.lineId != null ? filter?.lineId?.id : null
    let tripId = filter?.tripId != null ? filter?.tripId?.id : null
    let id = filter?.ticketNumber;
    let cashier = filter?.cashier;
    let ticketType = filter?.ticketType;
    if (salesTime) {
        salesTime = moment(salesTime).format("YYYY-MM-DD HH:mm:ss");
    }
    if (journeyDate) {
        journeyDate = moment(journeyDate).format("YYYY-MM-DD");
    }
    let location = null;
    if (filter?.locations && filter.locations.length > 0) {
        location = filter.locations.map(l => l.JID).join(',');
    }
    const parsedParams = customForSaleparsePaginationParams(params);
    return customAxiosBE.post(`/tickets/multipass-view?${parsedParams}`, {...filter, id, tripId ,carrierId, lineId ,isReturnTicket, directionType, ticketType, cashier, salesTime, journeyDate, location});
}


const MAX_PAGE_SIZE = 2000;
const PAGE_CONCURRENCY = 4;

export async function fetchAllTicketsMultiPassViewAPI(filter, {order = "desc", orderBy = "salesTime"} = {}) {
    const fetchPage = (page) =>
        ticketsMultiPassViewAPI({
            filter,
            params: {page, rowsPerPage: MAX_PAGE_SIZE, order, orderBy},
        }).then(({data}) => data || {});

    // Prva strana — iz nje čitamo ukupan broj rezultata i broj strana.
    const firstData = await fetchPage(0);
    const content = Array.isArray(firstData.content) ? [...firstData.content] : [];

    const totalPages =
        typeof firstData.totalPages === "number" && firstData.totalPages > 0
            ? firstData.totalPages
            : typeof firstData.totalElements === "number"
                ? Math.ceil(firstData.totalElements / MAX_PAGE_SIZE)
                : 1;

    // Preostale strane (1..totalPages-1) povlačimo u serijama radi ograničenja opterećenja.
    for (let start = 1; start < totalPages; start += PAGE_CONCURRENCY) {
        const end = Math.min(start + PAGE_CONCURRENCY, totalPages);
        const batch = [];
        for (let page = start; page < end; page++) {
            batch.push(fetchPage(page));
        }
        const results = await Promise.all(batch);
        results.forEach((data) => {
            if (Array.isArray(data.content)) content.push(...data.content);
        });
    }

    return {...firstData, content, totalElements: firstData.totalElements ?? content.length};
}

